{
    "BroadworksProvisioningHeader": "Broadworks Service Pack-Bereitstellung",
    "BroadworksProvisioningTableHeaderEnabled": "Ermöglicht",
    "BroadworksProvisioningTableHeaderItem": "Artikel",
    "BroadworksProvisioningTableHeaderServicePack": "Service Pack",
    "BroadworksProvisioningTableHeaderTelephonyServers": "Telefonieserver",
    "BroadworksProvisioningAddEntry": "Eintrag hinzufügen...",
    "BroadworksProvisioningItemExtension": "Verlängerung",
    "BroadworksProvisioningItemHospitality": "Gastfreundschaft",
    "BroadworksProvisioningItemAcdAgent": "ACD-Agent",
    "BroadworksProvisioningButtonDiscardChanges": "Änderungen verwerfen",
    "BroadworksProvisioningButtonSave": "Speichern",
    "BroadworksProvisioningButtonActions": "Aktionen",
    "BroadworksProvisioningButtonDelete": "Löschen",
    "BroadworksProvisioningButtonEdit": "Bearbeiten",
    "BroadworksProvisioningValueIsRequired": "Wert erforderlich.",
    "NAME": "Provisioning",
    "BroadworksProvisioningTableHeaderSendWelcomeEmail": "Willkommens-E-Mail senden",
    "BroadworksProvisioningItemEssentials": "Grundlegende Informationen",
    "BroadworksProvisioningItemProfessional": "Professionell",
    "BroadworksProvisioningItemCallCentreAgent": "Call-Center-Agent",
    "BroadworksProvisioningItemEnterprise": "Unternehmen",
    "BroadworksProvisioningItemCallCentreSupervisor": "Call-Center-Betreuer",
    "BroadworksProvisioningItem1000": "Akixi 1000",
    "BroadworksProvisioningItem2000": "Akixi 2000"
}